
<div class="container">
  <form #dartForm="ngForm" (ngSubmit)="send()">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <h4>Message to Transition Lead(s)</h4>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-8 card-block">
        <error [error]="error"></error>
        <div class="alert alert-success" [hidden]="!sent">
          <button class="close" type="button" (click)="sent = false"><span aria-hidden="true">&times;</span></button>Sent!
        </div>
        <div class="form-group">
          <label class="required" for="message"></label>Enter a message to send to the Transition Lead(s).  All Transition Leads assigned to this project will receive a copy of this message.
          <textarea class="form-control" id="message" [(ngModel)]="message" name="message" rows="5" required></textarea>
        </div>
        <div class="float-right">
          <div class="btn-group">
            <button class="btn btn-outline-secondary" type="button" (click)="cancel()">Back</button>
          </div>
          <div class="btn-group">
            <button class="btn btn-primary" type="submit">Send</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>